import React from 'react';
import { html } from 'lit';
import { querySelectorDeep } from 'omni-ui';
import '../../../../styles/rfpPreview.css';

// Shared components and utilities
import {
    OmniTileComponent, 
    OmniToolbarComponent, 
    OmniIconComponent, 
    OmniTooltipNextComponent, 
    OmniSearchComponent,
    OmniTableStickyComponent
} from '../../../../shared/components/omni-components';
import { tableUtils as TableUtils, AlertMessagesService } from '../../../../shared';

// Feature imports
import { PlacementDetailsTableService, CreatePlacementOrPackageService, PlacementUtils, PlacementDetailsTableSummaryHeader } from '../../';
import { CreateCreativeService } from "../../../creatives";
export class CreateLineAndChildPlacementTable extends React.Component {
    selectedDDValue  = null;
    selectedPlacementForNameEdit = {
        nameIndex: -1,
        rowIndex: -1
    }
    selectAllPlacementsChecked = true;
    allTaxonomyData = this.props.parentProps.allTaxonomyData;
    placementTaxonomyMap = this.props.parentProps.placementTaxonomyMap;

    constructor(props) {
        super(props);
        this.state = {
            programmaticformData:this.props.programmaticformData,
            taxonomyData:this.props.parentProps.taxonomyData,
            editDailog:this.props.parentProps.editDailog,
            placementCategory:this.props.parentProps.placementCategory,
            // createPackage:this.props.parentProps.createPackage,
            programmaticParentId:this.props.parentProps.programmaticParentId,
            programmaticUpdateformData:null,
            programmaticType:this.props.programmaticType,
            filterApplied:false,
            searchParam:'',
            tableData : [],
            addMorePlacement : null,
            budget:null,
            budgetArray:[],
            selectedData:[],
            storeTableData :[],
            addLineItem: '',
            socialProgrammaticFlag:this.props.placementCategory?.type.includes('Social') ,
            deletedItems:[],
            systemParametersData:this.props.systemParametersData,
            campaignObj:this.props.campaignObj
        } 
    }

    componentDidMount(){
        let tableData = [];
        let programmaticformData = this.createIds([{...this.props.programmaticformData}]);
        let placementObj = this.createPlacementNameAndSchema(this.props?.programmaticType,...programmaticformData);
        let currencyName = this.state.campaignObj.local_currency_name;
        let isLocal = this.state.systemParametersData.data.isLocal;
        //if condition will run if we are editing placement with already existing placements
        if(this.props.editDailog && !placementObj['PMDS Name']){
            let childList = this.props.parentChildPlacements;
            let childPlacements = this.setChildPlacementForEdit(childList,isLocal,currencyName);
            
            tableData = childPlacements;
        }else{
            tableData =[{...placementObj}];
            tableData[0].checked = false;
            tableData[0].programmaticType = this.props.programmaticType;
        }
        //programmaticformData is object and table data updaing as array
        this.setState({tableData:tableData,programmaticUpdateformData:placementObj,budget:this.props.programmaticformData['Planned Cost']},()=>{
            this.getlineItemPayload(true);
            let parentNode = document.getElementById('package-line-table')?.shadowRoot;
            let placementRow = querySelectorDeep('omni-table', 'right-table',parentNode);
            if (tableData?.length) {
                let ele = placementRow?.shadowRoot.getElementById(`delete-btn-${tableData[0]?.id}`);
                ele && ele.setAttribute('disabled', true);
            }
        });
        this.selectedPlacementForNameEdit.rowIndex= -1;
        this.selectedPlacementForNameEdit.nameIndex= -1;   
    }

    componentDidUpdate(prevProps, prevState){
        if(Number(this.state.programmaticformData["Rate"]) !== Number(this.props.programmaticformData['Rate'])|| Number(this.state.budget) != Number(this.props.programmaticformData['Planned Cost'])){
            this.changeRateAndUnitValue();     
        }
    }

    /**
     * Set Child placement for inline table
     */
    setChildPlacementForEdit (childList,isLocal,currencyName) {
        let nestedPlacement = []
        childList?.forEach(placement=>{
            if(placement?.package_type){
                let fields = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.placementTaxonomyMap, this.allTaxonomyData);
                let placementDetail = PlacementDetailsTableService.createformDataForEditPlacement(placement,fields,this.allTaxonomyData.defaultTaxonomyData.fields,this.state.socialProgrammaticFlag, isLocal, currencyName);
                if(placement?.nestedData?.length){
                    placement.nestedData = this.setChildPlacementForEdit(placement?.nestedData,isLocal,currencyName); 
                }else {
                    if(placement.package_type === 'DSP') {
                        placement['nestedData'] = [];
                    } else {
                        delete placement['nestedData'];
                    }
                }
                placement = {...placement,...placementDetail};
                nestedPlacement.push(placement);
            }
        });
        return nestedPlacement;
    }

    /**
     * Changing Rate and Unit value if parent placement Rate and Unit got change
     */
    changeRateAndUnitValue(){
        let tableData =[...this.state.tableData];  
        if(this.state.programmaticformData["Rate"] !== this.props.programmaticformData['Rate']){
            tableData.forEach(val=>{
                val['Rate'] = 0
                val['Unit Amount'] = 0
                val['Planned Cost'] =  val['Rate'] * val['Unit Amount'];
            });
            this.setState({tableData:tableData,programmaticformData:this.props.programmaticformData},()=>{
                this.getlineItemPayload();
                this.calculateBudget();
            });
        }else if(Number(this.state.budget) != Number(this.props.programmaticformData['Planned Cost'])){
            this.setState({programmaticformData:this.props.programmaticformData},()=>{
                this.calculateBudget();
            });
        }
    }
    /**
     * get all value from table and create childItem payload for programatic package
     * send all payload to placement modal
     */
    getlineItemPayload(isCallOnLoadd = false){
        this.calculateBudget();
        let payload = CreatePlacementOrPackageService.createPackageChildItemsPayload(
            this.state.tableData,
            this.props.parentProps.omniProfile,
            this.props.editDailog
            )
        //added delete placement id in playload, All id on child level include cretive id too
        if(this.props.editDailog){
            payload.push(...this.state.deletedItems);
        }
        this.props.lineItemProgramatic(payload,isCallOnLoadd);

        setTimeout(() => {
            let parentNode = document.getElementById('package-line-table')?.shadowRoot;
            let leftTableEle  = querySelectorDeep('omni-table', 'left-table',parentNode);
            if(leftTableEle){
                leftTableEle.style.paddingBottom = '120px'
            }
            let tableData = this.state.tableData
            let placementRow = querySelectorDeep('omni-table', 'right-table',parentNode);
            let ele = placementRow?.shadowRoot.getElementById(`delete-btn-${tableData[0].id}`);
            
            if(tableData?.length == 1){
                ele && ele.setAttribute('disabled', true);
            }else{
                ele && ele.removeAttribute('disabled');
            }
        })
    }

    /**
     * Calculate budget for line item from package value
     */
    calculateBudget(){
        let tableData = this.state.tableData;
        let budgetArray = [];
        tableData?.forEach(values=>{
            let obj = {
                planned_cost:values['Planned Cost'],
                unit_amount:values['Unit Amount']
            }
            budgetArray.push(obj);
        });
        this.setState({budgetArray:budgetArray,budget:this.props.programmaticformData['Planned Cost']}); 
    }

    /**
     * function is to create left column for sticky table
     * if ad serving and verification fee value is not there then function will remove ad serveing and verification column
     */
    getLeftColumn(){ 
        const dataValue = 'Line Item Name'
        return  [
        {
        label: html`
        <omni-checkbox
                id="line-placements-table-selectall"
                part="select-placement-checkbox"
                style=" --checkbox-height-width: 1rem; --checkbox-border-color: #837f7f; margin-left: 1.3rem;"
                @change=${(event) => this.selectAllPlacements(event)}
                ></omni-checkbox>`,
        key: "id",
        template: (value, index) => {
            return html`
            <style>
                :host td{
                    overflow: revert !important;
                }

                 :host::part(table-body-cell) {
                    cursor: pointer;
                    position: relative;
                    text-align: left;
                    padding-left: 0 !important;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    text-align: initial;
                    line-height: normal;
                    vertical-align: bottom;
                } 
                 :host::part(table-body-cell-no-child) {
                    padding-left:10px;
                        display: flex;
                        padding-left: 10px;
                        justify-content: center;
                        margin-top: 21px;
                } 

                :host::part(checkbox-column) {
                    margin-left:5px;
                    display: flex;
                }
                :host::part(table-body-cell-creative) {
                    cursor: pointer;
                    position: relative;
                    text-align: left;
                    padding:1rem; 
                    padding-left:3.4rem; 
                }

                :host::part(placement-name):hover {
                    color: rgb(0 161 210);
                    cursor: pointer;
                }
        
                :host::part(placement-name-disabled) {
                    cursor: not-allowed;
                }
                
                .popup-placement-modal {
                    min-width: 12rem;
                    padding-top: 4px;
                    position: absolute;
                    top: 100%;
                    z-index: 20;
                    display: none;
                }

                :host::part(placementName){
                    display: inline;
                }
                
                :host::part(dropdown is-active) {
                    display: block;
                }

                :host::part(placement-name-cancel-button){
                    margin-right: 20px !important;
                }
            
                :host::part(table-body) {
                    transform-style: initial;
                }
                
                :host::part(table-body-row) {
                    transform: initial;
                }
                
                :host::part(table-header-actions) {
                    text-align: center;
                }
                
                :host::part(cell-input) {
                    width: 100px;
                    padding: 6px 0 6px 15px;
                }
                :host::part(checkbox-column) {
                    margin-left:30px;
                    display: flex;
                }
                :host::part(action-dropdown-item){
                    color: #3b3e3f;
                    font-size: 14px;
                }
                
                :host::part(dropdown-content){
                    border-radius: 10px;
                }
                
                :host::part(margin-left-20) {
                    margin-left: 20px !important;
                }
                
                :host::part(margin-left-10) {
                    margin-left: 10px;
                }

                :host::part(select-placement-checkbox){
                    accent-color: var(--fill-primary);
                }
                .expand-wrapper.is-clamped {
                    max-width: 151px !important;
                }
            </style>
                ${value.programmaticType === 'Placement' || value.programmaticType?.includes('Line Item') ? 
                    html`<div part="${value.nestedData?.length || value.parent_type == "ProgrammaticPlacement" ? 'table-body-cell':'table-body-cell-no-child'}" id="td-${index}">
                    <div part="checkbox-column" @click=${(e) => this.handleCheckboxChange(index, e)}>  
                        <omni-checkbox
                        style=" --checkbox-height-width: 1rem; --checkbox-border-color: #837f7f;"
                        part="placement-checkbox"
                        id="input-${value && index}"
                        name="${value.id}"
                        ?checked=${value.checked}></omni-checkbox>
                    </div>
                </div>`:''
                }`
        },
        isSortable: false,
        passthrough: true,
        },
        {
            label: dataValue,
            key: 'Placement Name',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                return html`
                <style>
                    :host::part(margin-left-10) {
                        margin-left: 10px;
                    }
                    :host::part(margin-left-20) {
                        margin-left: 20px;
                    }
                    :host::part(margin-left-30) {
                        margin-left: 30px;
                    }
                    :host::part(margin-left-40) {
                        margin-left: 40px;
                    }
                </style>
                <td part="${!value.creative_id ?'table-body-cell':'table-body-cell-creative'}">
                    ${value.creative_id ?  
                    html `<span>${value.creative_name}</span>` : this.getPlacementName(value, index)}
                </td>`
            }
        },
        {
            label: 'COST METHOD',
            key: 'costMethod',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                if(value.programmaticType === 'Placement' || value.programmaticType?.includes('Line Item')){
                    return html`<td part="table-body-cell">
                        ${this.getCostMethod('costMethod',value,index)}
                    </td>`;
                }else{
                    return html`<td part="table-body-cell"></td>`;
                }
            }
        },
        {
            label: 'RATE',
            key: 'Rate',
            default: '',
            passthrough: true,
            template: (value, index) => {
                if(value.programmaticType === 'Placement' || value.programmaticType?.includes('Line Item')){
                    return html`<td part="table-body-cell">
                    ${this.getRate('Rate',value, index)}
                    </td>`;
                }else{
                    return html`<td part="table-body-cell"></td>`;
                }
            }
        },
        {
            label: 'UNITS',
            key: 'Unit Amount',
            default: '',
            isSortable: true,
            passthrough: true,
            template: (value, index) => {
                if(value.programmaticType === 'Placement' || value.programmaticType?.includes('Line Item')){
                    return html`<td part="table-body-cell">
                    ${this.getUnits('Unit Amount',value, index)}
                    </td>`;
                }else{
                    return html`<td part="table-body-cell"></td>`;
                }
            }
        },
        {
            label: 'AMOUNT',
            key: 'Planned Cost',
            default: '',
            passthrough: true,
            template: (value, index) => {
                if(value.programmaticType === 'Placement' || value.programmaticType?.includes('Line Item')){
                    // const displayValue=value['Planned Cost']?`${(Number(value['Planned Cost']))?.toLocaleString('en-US', {style: "currency", currency: "USD"})}`:'';
                    return html`<td part="table-body-cell">
                    ${this.getCostAmount('Planned Cost',value, index)}
                    </td>`
                }else{
                    return html`<td part="table-body-cell"></td>`;
                }
            }
        },  
        ];
    }

    /**
     * function is to create right side of crolumn for sticky table
     */
    getRightCoumn(){
        return  [
            {
                label: 'Actions',
                key: 'actions',
                passthrough: true,
                template: (value, index) => {
                    return html`
                    <style>
                    :host td{
                        overflow: revert !important;
                    }
                    :host::part(table-header-cell) {
                        height: 46.7773px;
                    }
                    
                    :host::part(table-body-cell) {
                      cursor: pointer;
                    }
                    
                    :host::part(action-button-icon) {
                      width:20px; 
                      height: 20px;
                    }
                                        
                    :host::part(dropdown is-active) {
                      display: block;
                    }
                    
                    :host::part(placement-name-cancel-button){
                      margin-right: 20px !important;
                    }
                    
                    :host::part(table-body-cell) {
                      position: relative;
                    }
                    
                    
                    :host::part(table-body) {
                      transform-style: initial;
                    }
                    
                    :host::part(table-body-row) {
                      transform: initial;
                    }
                    
                    :host::part(table-header-actions) {
                      text-align: center;
                    }
                    
                    :host::part(action-dropdown-item){
                      color: #3b3e3f;
                      font-size: 14px;
                    }
                    
                    :host::part(dropdown-content){
                      border-radius: 10px;
                    }
                    
                    </style>
    
                    <td part="table-body-cell">
                        ${value.creative_id ? '' : this.getActions(value, index)}
                    </td>`
                }
            }
        ]
    }

    /**
     * table single check box function to handel checkbox and set on selected list state
     * @param {*} index row index
     * @param {*} event input event
     */
    handleCheckboxChange(index,event){
        const target = /** @type {HTMLDivElement} */ (event.target);
        const checked = { checked: target.checked };
        let table = [...this.state.tableData];
        let tempSelectedData = {...table[index],...checked};
        table[index] = {...tempSelectedData};
        let selectedData = table.filter(val=>{
            return val.checked == true;
        });
       
        this.#checkUncheckTheAllCheckbox(table);
        this.setState({selectedData:selectedData,tableData:table});
    }
    
    /**
     * Handel parent check box for all checkbox
     * And set selected list to state
     * @param {*} event input event
     */
    selectAllPlacements = (event) => {
        const checkbox = /** @type {HTMLInputElement} */ (event.target);
        this.selectAllPlacementsChecked = checkbox.checked;
        let table = [...this.state.tableData];
        table.forEach(val=>{
            val.checked = this.selectAllPlacementsChecked;
        });
        if(this.selectAllPlacementsChecked){
            this.setState({selectedData:table});
           
        }else{
            this.setState({selectedData:[],});
        }
        this.setState({tableData:table},()=>{
            setTimeout(() => {
                this.checkUnCheckPlacements(this.state.tableData);
            })
        });
    };

    /**
     * Mark check or Uncheck or placement checkboxs
     * @param {Array} table 
     */
    checkUnCheckPlacements(table){
        table.forEach((val,index)=>{
            let parentNode = document.getElementById('package-line-table').shadowRoot;
            const checkboxEl = /** @type {HTMLInputElement} */ (querySelectorDeep('omni-table', 'left-table',parentNode).shadowRoot.getElementById(`input-${index}`));
            checkboxEl.checked = val.checked;
            
        });
        this.#checkUncheckTheAllCheckbox(table);
    }
    /**
     * check or uncheck the all checkbox, without any side effects
     * @param {TableData} currData
     * @returns {void}
     */
    #checkUncheckTheAllCheckbox(currData) {
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        const checkboxEl = /** @type {HTMLInputElement} */ (querySelectorDeep('omni-table', 'left-table',parentNode).shadowRoot.getElementById("line-placements-table-selectall"));
        checkboxEl.checked = this.#flatten(currData).every((one) => one.checked);
    }

    /**
     * check all row are selected
     * @param {array} data 
     * @returns 
     */
    #flatten(data) {
        let flattened = [];
        const walk = (levelData) => {
            for (const row of levelData) {
                flattened.push(row);
            }
        };
        walk(data);
        return flattened;
    }

    /* The below code is a JavaScript function that takes in a value and an index as parameters.
    * actions that can be taken on the value. These actions include creative btn, copying, deleting to
    * create html btn for all button 
    * disabled copy if creative taxonomy not there while edit
    */
    getActions = (value, index) => {
        let isCreativeTaxonomyAvialable = PlacementUtils.checkCreativeTaxonomy(value,this.allTaxonomyData);
        let isLineItemTaxonomyAvialable = this.allTaxonomyData['dspPackageTaxonomyData']?.fields?.length;
        let lineItemeBtnTooltip = !isLineItemTaxonomyAvialable ? 'Line Item Taxonomy Schema is not available' : 'Add Line Item';
        let creativeBtnTooltip = !isCreativeTaxonomyAvialable ? 'Creative Taxonomy Schema is not available' : 'Add Creative';
        let isLineItem = value?.programmaticType?.includes('Line Item');
        let isCreative = value?.programmaticType?.includes('Creative');
        return html`
            <div style="display: flex;justify-content: right;" class="table-row-actions">
            ${ !isCreative && !isLineItem
                    ? html`<omni-tooltip-next>
                    <button slot="invoker" aria-haspopup="true" class="icon">
                        <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:plus"  
                        @click=${(e) => {(isLineItem && !isCreativeTaxonomyAvialable) || (!isLineItem && !isLineItemTaxonomyAvialable) ? "" : this.openPopupCopyAndAddMorePlacement(isLineItem ? 'creatives' : 'LineItem', index,value.id)}}></omni-icon>
                    </button>
                    <div slot="content">${!isLineItem ? lineItemeBtnTooltip : creativeBtnTooltip}</div>
                </omni-tooltip-next>`
                    : html``
            } 
                <omni-tooltip-next>
                    <button slot="invoker" aria-haspopup="true" class="icon" style="padding:0 30px" @click="${() => this.openPopupCopyAndAddMorePlacement('copies', index,value.id)}">
                        <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:copy"></omni-icon>
                    </button>
                    <div slot="content">Copy</div>
                </omni-tooltip-next>
                <omni-tooltip-next>
                    <button slot="invoker" aria-haspopup="true" class="icon delete-placement-btn" id="delete-btn-${value.id}"  @click=${(e) => {this.deletePlacement(value.id, index)}}>
                        <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:delete"></omni-icon>
                    </button>
                    <div slot="content">Delete</div>
                </omni-tooltip-next>
                ${!isCreative ? this.popupAddMorePlacement(index,isLineItem ? 'creatives' : 'LineItem',value) : ''}
                ${this.popupAddMorePlacement(index,'copies',value)}
            </div>`
    }

    /**
     * Copy placement from table
     * @param {object} placement 
     * @param {number} index 
     */
    copyPlacements(placement=null,copyType = null){
        let tableData =[...this.state.tableData];
        if(copyType === 'bulkCopy'){
            let selectedCopy = [];
            for(let i=0; i<this.state.selectedData.length;i++){
                let placementCopy = this.replaceTaxonomyValueField(this.state.selectedData[i]);
                selectedCopy.push(placementCopy);
            }
            let selectedDataWithId = this.createIds(selectedCopy);
            selectedDataWithId = this.calculateRemaingBudget(selectedDataWithId);
            tableData = [...this.state.tableData,...selectedDataWithId];
        }else{
            let placementObj = {...placement,checked:false};
            let placementArr = [];
            for(let i= 0; i< this.state.addMorePlacement;i++){
                placementArr.push({...placementObj});
            }
            let isProgrammaticPlacementAvailable = this.state.socialProgrammaticFlag ? this.allTaxonomyData.socialProgrammaticPlacementTaxonomyData?.fields?.length : this.allTaxonomyData.programmaticPlacementTaxonomyData?.fields?.length;
            placementArr = this.createIds(placementArr);
            if(placement.programmaticType === 'Placement' || (placement.programmaticType.includes('Line Item') && !isProgrammaticPlacementAvailable)){
                placementArr = this.calculateRemaingBudget(placementArr);
                tableData.push(...placementArr);
            } else if((placement.programmaticType.includes('Line Item') && isProgrammaticPlacementAvailable) || (placement.programmaticType.includes('Creative') && !isProgrammaticPlacementAvailable)){
                let nestedIndex = null;
                let parentIndex = null;
                 tableData.forEach((val,i) => {
                    nestedIndex = val?.nestedData?.findIndex(value=> value.id == placement.id);
                    if(nestedIndex > -1){
                        parentIndex = i;
                    }
                });
                tableData[parentIndex].nestedData.push(...placementArr);
            }else if(placement.programmaticType.includes('Creative') && isProgrammaticPlacementAvailable){
                let nestedIndex = null;
                let parentIndex = null;
                tableData.forEach((val,i) => {
                    nestedIndex = val?.nestedData?.nestedData?.findIndex(value=> value.id == placement.id);
                    if(nestedIndex > -1){
                        parentIndex = i;
                    }
                });
                tableData[parentIndex].nestedData.nestedData.push(...placementArr);
            }
        }
        tableData.forEach(val=>{
            val.checked = false;
            if(this.props.editDailog && val['Placement Name']?.includes(':|') && !Number(val.id)){
                val['Placement Name'] = val['Placement Name'].split(':|')[0];
            }
            if(val.nestedData && val.nestedData.length == 0){
                delete val["nestedData"]
            }else if(val.nestedData && val.nestedData.length){
                val.nestedData.forEach(chidlVal=>{ 
                    if(this.props.editDailog && chidlVal['Placement Name']?.includes(':|') && !Number(chidlVal.id)){
                        chidlVal['Placement Name'] = chidlVal['Placement Name'].split(':|')[0];
                    }
                });
            }
        });
        this.setState({selectedData:[],tableData:tableData},()=>{
            this.getlineItemPayload();
            if(tableData.length>1){
                let parentNode = document.getElementById('package-line-table').shadowRoot;
                let allDeleteBtn = querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.querySelectorAll(".delete-placement-btn");
                allDeleteBtn?.forEach(element => {
                    element.removeAttribute("disabled");    
                });
            }
            setTimeout(() => {
                this.checkUnCheckPlacements(this.state.tableData);
            })
        }); 
    }

    /**
     * Get array of Object and assign unique id to all object
     * @param {Array} data 
     * @returns Array of object with unique ids
     */
    createIds(data){
        let plamentArray = [...data];
         let arr = [];
         plamentArray.forEach((element,index) => {
            let parentObj = {...element};
            parentObj.id = (((1+Math.random())*0x10000)|0).toString(16)+index+'id';
            if(parentObj?.nestedData?.length){
                let nestedArry = [];
                parentObj.nestedData.forEach((nestElement,index) => {
                    let obj = {...nestElement};
                    obj.id = (((1+Math.random())*0x10000)|0).toString(16)+index;
                    nestedArry.push({...obj})
                });
                parentObj.nestedData = [...nestedArry];
            }
            arr.push({...parentObj}); 
        });
        return arr;
    }
     /**
     * Add Creative Placement under line item
     * @param {number} index placement Index
     */
     addCreativePlacements(index,placementType,placement){
        let placementObj = {...placement};
        //we are not show any rate unit and cost amount for creative placement
        placementObj['Planned Cost'] = null;
        placementObj['Unit Amount'] = null;
        placementObj['Rate'] = null
        delete placementObj.nestedData;
       
        let tableData =[...this.state.tableData]; 
        let isProgrammaticPlacementAvailable = this.state.socialProgrammaticFlag ? this.allTaxonomyData.socialProgrammaticPlacementTaxonomyData?.fields?.length : this.allTaxonomyData.programmaticPlacementTaxonomyData?.fields?.length;
        let parentItem = {};

        if(placementType.includes('Creative') && !isProgrammaticPlacementAvailable || placementType.includes('Line Item') && isProgrammaticPlacementAvailable){
            parentItem = tableData[index];
        } else if(placementType.includes('Creative') && isProgrammaticPlacementAvailable){
            let flatData = TableUtils.flattenData(tableData);
            parentItem = flatData.find(val=> val.id == placementObj.id);
        }

        placementObj = this.createPlacementNameAndSchema(placementType,placementObj);
        let creativePlacement = [];
        for(let i= 0; i< this.state.addMorePlacement;i++){
            creativePlacement.push({...placementObj});
        }
        creativePlacement = this.createIds(creativePlacement);
        parentItem.nestedData = parentItem.nestedData ? parentItem.nestedData.concat(creativePlacement) : creativePlacement;
        this.setState({selectedData:[],tableData:tableData},()=>{
            this.getlineItemPayload();
        }); 
    }

    /**
     * Create Placement name and schema accroding to placement schema type , if value is not there then 
     * add NU in name and diplay name
     * @param {String} placementType 
     * @param {Object} placement 
     * @returns 
     */
    createPlacementNameAndSchema(placementType,placement){
        if(placement.isOverride){
            return {...placement,programmaticType : placementType};
        }
        let schema, placementName, placementDisplayName, creationParentType, creationPackageType;
        schema = placementName = placementDisplayName   = creationParentType = creationPackageType = '';
        let isProgrammaticPlacementAvailable = this.state.socialProgrammaticFlag ? this.allTaxonomyData.socialProgrammaticPlacementTaxonomyData?.fields?.length : this.allTaxonomyData.programmaticPlacementTaxonomyData?.fields?.length;
        if(placementType === "Placement"){
            creationParentType = "ProgrammaticPackage";
            creationPackageType = "ProgrammaticPlacement";
        } else if(placementType?.includes("Line Item")){
            creationParentType = isProgrammaticPlacementAvailable ? "ProgrammaticPlacement" : "ProgrammaticPackage";
            creationPackageType = "DSP";
        } else if(placementType?.includes("Creative")){
            creationParentType = "DSP";
            creationPackageType = "Child";
        }
        let creationPlacementType = this.state.socialProgrammaticFlag ? "Social": "";

        let childTaxonomy = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(creationPackageType, creationPlacementType, creationParentType),this.placementTaxonomyMap, this.allTaxonomyData);
        let formData = {}
        if(this.props.editDailog  && !placement?.taxonomy){
            let parentFields = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(creationParentType, creationPlacementType, ""), this.placementTaxonomyMap, this.allTaxonomyData)?.fields;
            let { schemaArr, editFormData }  = PlacementDetailsTableService.getFormEditData(parentFields,placement);
            formData = editFormData
        }else{
            formData = placement
        }
        let isHiddenField = childTaxonomy?.fields?.filter(field=> field.hidden == false)?.length
        let {taxonomySelectedValueJson} = PlacementUtils.createNames(formData,childTaxonomy,true)

        placementName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,childTaxonomy?.fields);
        placementDisplayName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',false,childTaxonomy?.fields);

        schema = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'field_name',false,childTaxonomy?.fields);
        if(isHiddenField){
            placement["Override Placement Name"] =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',true,childTaxonomy?.fields);
            placement["Override Placement Display Name"]  = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',true,childTaxonomy?.fields);
        }
        // just delete field_name, name from taxonomySelectedValueJson before saving in state
        taxonomySelectedValueJson = taxonomySelectedValueJson.map((item) => {
            delete item['field_name'];
            delete item['name'];
            delete item['hidden'];
            return item;
        });
        formData['taxonomy'] = taxonomySelectedValueJson;
        formData['taxonomy_client_id'] = childTaxonomy?.clientid;
        formData['taxonomy_schema_id'] = childTaxonomy?.id;
        return  {...formData,programmaticType : placementType,'Placement Name':placementName,'Placement Display Name':placementDisplayName,'Placement Schema':schema, package_type: creationPackageType, placement_type: creationPlacementType, parent_type: creationParentType};
    }
    /**
     * Delete placement from table && store id of delete placement to send in playload in edit case 
     * @param {object} placement 
     * @param {number} index 
     */
    deletePlacement(id,index){
        let tableData = [...this.state.tableData];
        let deletedItems = this.state.deletedItems;
       
        this.deleteSelectedPlacement(tableData, id, deletedItems);
            
        this.setState({tableData:tableData,deletedItems:deletedItems},()=>{
            this.getlineItemPayload();
            if(tableData.length === 1) {
                tableData[0]['costMethod'] = this.props.programmaticformData['costMethod'];
                tableData[0]['Unit Amount']  = this.props.programmaticformData['Unit Amount'];
                tableData[0]['Planned Cost']  = this.props.programmaticformData['Planned Cost'];
                let parentNode = document.getElementById('package-line-table').shadowRoot;
                let placementRow = querySelectorDeep('omni-table', 'right-table',parentNode);
                let ele = placementRow?.shadowRoot.getElementById(`delete-btn-${tableData[0].id}`);
                // ele && ele.setAttribute('disabled', true);
            }
        }); 
    }

    deleteSelectedPlacement = (tableData, deleteId, deletedItems) => {
        for(let i=tableData?.length - 1; i >= 0; i--){
            if(tableData[i].id === deleteId){
                let flatData = TableUtils.flattenData([tableData[i]]);
                flatData.forEach(val=>{
                    deletedItems.push({
                        id:val.id,
                        isDelete:true
                    });
                });
                tableData.splice(i, 1);
                return;
            } else {
                if(tableData[i].nestedData){
                    this.deleteSelectedPlacement(tableData[i].nestedData, deleteId, deletedItems);
                }
            }
        }
    }
    /**
     * open modal to enter number of line item you want to create or copy
     * @param {string} popupType 
     * @param {number} index 
     */
    openPopupCopyAndAddMorePlacement(popupType,index,id){
        //hide all movePlacementDropdown
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        const addMorePlacementDropdown = querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.querySelectorAll(".popup-placement-modal");
        if(addMorePlacementDropdown.length > 0 ){
        addMorePlacementDropdown.forEach(element => {
            element.setAttribute("part","dropdown");    
        });
        }
        let editPlacementPoup = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.querySelectorAll(".popup-placement-modal");
        if(editPlacementPoup && editPlacementPoup.length > 0){
            editPlacementPoup.forEach(element => {
                element.setAttribute("part","dropdown");    
            });
        }
        let temp = querySelectorDeep('omni-table', 'right-table',parentNode);
        let ele = temp?.shadowRoot.getElementById(`popup-${popupType}-${index}-${id}`);
        ele && ele.setAttribute('part', 'dropdown is-active');
        const eleRect = querySelectorDeep('omni-table', 'right-table',parentNode).getBoundingClientRect();
        const targetRect = ele.getBoundingClientRect();
        const bottomPos = eleRect.bottom - targetRect.bottom;

        if(bottomPos < ele.offsetHeight){
            ele.style.marginTop  = `-${ele.offsetHeight + 50}px`
        }else{
            ele.style.marginTop  = `auto`
        }

        this.movePlacementValue = "";        
        querySelectorDeep('omni-table', 'right-table')?.shadowRoot.getElementById(`aply-btn-${popupType}-${index}`)?.setAttribute('disabled', true);
    }

    /**
     * create modal for creative and copy modal
     * @param {number} index 
     * @param {string} popupType 
     * @returns 
     */
    popupAddMorePlacement(index,popupType,value) {
        let placeholder = `Enter number of ${popupType}`
        let inputValue =''
        let applyButtonId = `aply-btn-${popupType}-${index}-${value.id}`;
        let header = `# of ${popupType}`
        let res = html`
        <style>
        :host::part(dropdown) {
            min-width: 12rem;
            padding-top: 4px;
            position: absolute;
            top: 100%;
            z-index: 20;
            display: none;
        }

        :host::part(dropdown is-active) {
            display: block;
        }
        :host::part(dropdown-header) {
            text-align: left;
        }
        :host::part(add-more-name-cancel-button){
            margin-right: 20px !important;
        }
          
          </style>
            <div part="dropdown" style="width: 349px" class="popup-placement-modal popup-add-more-placement" id="popup-${popupType}-${index}-${value.id}">
            <div part="dropdown-menu" class="dropdown-menu1" role="menu">
                <div part="dropdown-content" class="dropdown-content" style="display: flex;flex-direction:column;padding: 10px 20px;">
                <section part="dropdown-header">
                    <p class="object-title">${header}</p>
                </section>    
                <section part="dropdown-section" class="dropdown-item" style="padding-left: 4px">
                        <div part="dropdown-item" style="margin: 15px 0 20px 0">
                            <div class="full-width">
                                <input part="input-control"
                                style="width: 100%;"
                                .value="${this.state.addMorePlacement}"
                                placeholder="${placeholder}"
                                @input="${this.onAddMoreInputChange.bind(this,applyButtonId)}"></input>
                            </div>
                        </div>
                        <div class="action-btns" style="display: flex; justify-content: flex-end;align-items: center">
                        <button part="add-more-name-cancel-button" @click=${(e) => this.popupMoreActionCancelBtn(index,popupType,applyButtonId,value)} >Cancel</button>
                        <button part="add-more-name-apply-button" id="${applyButtonId}" disabled="true"  @click=${(e) => this.popupMoreActionApplyBtn(index,popupType,applyButtonId,{...value})}>Apply</button>
                        </div>
                    </section>
                </div>
            </div>
            </div>`;
        return res;
    }

    /** 
    * Description; to change the input value 
    * if vlaue enter apply button get enable
    * @param {any} placement
    * @param {any} fieldName
    * @param {any} applyButtonId
    * @param {any} event
    * @returns {any}
    */
    onAddMoreInputChange = (applyButtonId,event) => {
        const updatedValue =Number( event.target.value);
        let partString = 'add-more-name-apply-button'
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        if(updatedValue){
            this.setState({addMorePlacement:updatedValue});
            partString = 'add-more-name-apply-button active'
            querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.removeAttribute('disabled');
        }else{
            querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('disabled',true)
        }
        querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', partString)
    }

    /**
     * Recursively replace TaxonomyValueID in placement and its nestedData
     * @param {object} placement
     * @returns {object} - The updated placement object
    */
    replaceTaxonomyValueField = (placement) => {
        // Replace existing TaxnomyValuID to {TaxonomyValueID} for new code generation
        const deepReplace = (placementCopy) => {
            if (placementCopy && placementCopy.taxonomy?.length) {
                let existingTaxonomyValue = placementCopy.taxonomy.filter((item) => item.field_name === "TaxonomyValueID");
                if (existingTaxonomyValue.length) {
                    let previousVal = existingTaxonomyValue[0].code;
                    existingTaxonomyValue[0].code = `{TaxonomyValueID}`;
                    existingTaxonomyValue[0].name = `{TaxonomyValueID}`;
                    for (let key of Object.keys(placementCopy)) {
                        if (['placement_taxonomy', 'placement_taxonomy_display', 'overriden_placement_taxonomy', 'overriden_placement_display_taxonomy', 'Placement Name', 'Placement Display Name', 'TaxonomyValueID'].includes(key)) {
                            placementCopy[key] = placementCopy[key].replace(previousVal, existingTaxonomyValue[0].code);
                        }
                    }
                }
            }
            if (placementCopy.nestedData?.length) {
                placementCopy.nestedData.forEach((nestedPlacement) => {
                    deepReplace(nestedPlacement);
                });
            }
        }
        // Deep copy to avoid mutating the original placement object
        let placementCopy = structuredClone(placement) || JSON.parse(JSON.stringify(placement));
        deepReplace(placementCopy);
        return placementCopy;
    }
    
    /**
     * on apply it will call copy function that copy clicked placement
     * creative modal will create list of creative modals
     * @param {number} index 
     * @param {string} popupType 
     */
    popupMoreActionApplyBtn(index,popupType,applyButtonId,placement){
        let placementObject = this.replaceTaxonomyValueField(placement);
        if(this.props.editDailog && placement['Placement Name']?.includes(':|')){
            placementObject['Placement Name'] = placementObject['Placement Name'].split(':|')[0];   
        }
        if(popupType == 'copies'){
            this.copyPlacements(placementObject);
        }else{
            this.addCreativePlacements(index,popupType === 'creatives' ? 'Creative Placement' : 'Line Item',placementObject);
        }
        this.popupMoreActionCancelBtn(index,popupType,applyButtonId,placementObject);
    }
    
    /**
     * close modal of copy and creative and disable apply btn
     * @param {number} index 
     * @param {string} popupType 
     * @param {string} applyButtonId 
     */
    popupMoreActionCancelBtn(index,popupType,applyButtonId,value){
        this.setState({addMorePlacement:null});
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('disabled',true);
        querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', 'add-more-name-apply-button');
        let ele = querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.getElementById(`popup-${popupType}-${index}-${value.id}`);
        if(ele){
            ele.setAttribute('part', 'dropdown');
            ele.style.marginTop  = `auto`;
        }

    }

    /**
     *  update all cost value according to change number and send payload request to placement modal
     * @param {string} column - Defines which column is edited
     * @param {event} event - Native event received from listener
     * @param {object} value - json object of placement
     * @param {number} index - index of row
     *  */ 
    updatePlacementInlineChanges = (column, event, index, rowValue) => {
        let tableData = [...this.state.tableData];
        let flatData = TableUtils.flattenData(tableData);
        let rowToUpdate = flatData.find(val => val.id === rowValue.id);
        if(!rowToUpdate) return;

        let value = event.target.value;
        rowToUpdate[column] = value;
        let units = Number(rowToUpdate['Unit Amount']);
        let rate = Number(rowToUpdate['Rate']);
        let cost = Number(rowToUpdate['Planned Cost']);
        let costMethod = rowToUpdate['costMethod']
        //Using common method to calculate rate unit and planned cost
        let costValues =  PlacementUtils.getCostCalculation(units,rate,cost,costMethod,column);

        units = costValues.units;
        rate = costValues.rate;
        cost = costValues.cost;
        rowToUpdate["Unit Amount"] = Math.floor(units);
        rowToUpdate["Rate"] = rate;
        rowToUpdate["Planned Cost"] = cost;
        rowToUpdate["costMethod"] = costMethod;
        this.setState({tableData:tableData},()=>{
            this.getlineItemPayload();
        });  
    }

    /**
     * Cost Method column with drop own field 
     * @param {object} value - placement json
     * @param {number} index - row index
     * @returns {html element} displayValue - returns rate column with input field if required
     */
    getCostMethod = (column,value, index) => {
        const displayValue = value.costMethod;
        let type = value?.programmaticType === 'Placement' ? 'placement' : 'line';
        let fieldList = this.allTaxonomyData.defaultTaxonomyData.fields.find(item=> item.name == 'Cost Method').fielditems;
        let costMethodOptions = []
         fieldList.forEach(item=> {
            let obj = {
                label:item.name,
                value:item.code
            }
            costMethodOptions.push(obj);
        });
        return html`
        <om2-dropdown
            id=${type}-cost-method-${index}
            class="line-items-cost-method"
            .value="${displayValue}"
            .options="${costMethodOptions}"
            @change="${(event) => this.updatePlacementInlineChanges(column, event, index, value)}"
        ></om2-dropdown>`
    }
    /**
     * rate column with input field if required
     * @param {object} value - placement json
     * @param {number} index - row index
     * @returns {html element} displayValue - returns rate column with input field if required
     */
    getRate = (column,value, index) => {
        let displayValue = value[column];
        let type = value?.programmaticType === 'Placement' ? 'placement' : 'line';
        let costMethod = value?.costMethod;
        return html`
        <omni-tooltip-next>   
            <input id=${type}-rate-${index}
            part="cell-input"
            class="input is-static is-editable"
            type="text"
            .value=${displayValue}
            @blur=${(event) => this.updatePlacementInlineChanges(column, event, index, value)}
            .disabled=${costMethod === 'Flat'}>
            <span slot="content">${costMethod === "Flat" ? 'On selection of Flat as Cost Method, Rate will be disabled' : '' }</span>
        </omni-tooltip-next>
        `
    }
    /**
     * getUnits column with input field if required
     * @param {object} value - placement json
     * @param {number} index - row index
     * @returns {html element} displayValue - returns rate column with input field if required
     */
    getUnits = (column,value, index) => {
        let type = value?.programmaticType === 'Placement' ? 'placement' : 'line';
        let displayValue = value[column];
        return html`
        <input id=${type}-unit-${index}
        part="cell-input"
        class="input is-static is-editable"
        type="text"
        .value=${displayValue}
        @blur=${(event) => this.updatePlacementInlineChanges(column, event, index, value)}>`
    }
    /**
     * getCostAmount column with input field if required
     * @param {object} value - placement json
     * @param {number} index - row index
     * @returns {html element} displayValue - returns rate column with input field if required
     */
    getCostAmount = (column,value, index) => {
        let displayValue = value[column];
        let type = value?.programmaticType === 'Placement' ? 'placement' : 'line'
        return html`<input id=${type}-costamount-${index}
        part="cell-input"
        class="input is-static is-editable"
        type="text"
        .value=${displayValue}
        @blur=${(event) => this.updatePlacementInlineChanges(column, event, index, value)}>`
    }

     /**
     * The function `getPlacementName` takes a placement object and a row index as input and returns an
     * array of HTML elements representing the placement names for that placement.
     * @param placement - The `placement` parameter is an object that contains information about a
     * placement. It includes properties such as `override_taxonomy`, `placement_taxonomy`,
     * `nestedData`, `overriden_placement_taxonomy`, and `package_type`.
     * @param rowIndex - The `rowIndex` parameter is the index of the row in the table where the
     * placement is located. It is used to identify the specific placement within the table.
     * @returns an array of HTML elements representing rows of placement names.
     */
     getPlacementName(placement, rowIndex) {
        let displayName = placement['Placement Name'];
        let placementNameArr;
        let placementObj = {};
        let taxonomyData = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.placementTaxonomyMap, this.allTaxonomyData);
        let taxonomySchemaArray = taxonomyData ? PlacementUtils.mapDropdownValues(taxonomyData) : [];
        let synthecticId = '';
        if (!!placement.isOverride && placement['Override Placement Display Name']) {
            placement.schema_without_hidden = this.getSchemaWithoutHidden(placement);
        }else if(!placement.isOverride){
            placementObj = PlacementDetailsTableService.splitStringIntoArray(displayName, taxonomySchemaArray,':|',false,false,placement);
        }
        if(this.props.editDailog && placement.isOverride && displayName?.includes(':|')){
            let nameAndSyntheticId = displayName.split(':|');
            placementNameArr = [nameAndSyntheticId[0]];
            synthecticId = nameAndSyntheticId[1]
        }else{
            //Placement Object have Placement Name as array, synthetic id and last index of placement name arry
            placementNameArr = placementObj?.nameArr?.length?placementObj.nameArr:[displayName];
            //sythetic id use to display at the end of placement name and last index use it to disable it from editting   
            synthecticId = placementObj?placementObj.syntheticId:null;
        }
        
        //it create placement name in Table and user can edit it by click on any placement name value   
        let rows = placementNameArr.map((item, nameIndex) => {
            const fieldObj = taxonomySchemaArray?.length ? taxonomySchemaArray[nameIndex] : '';
            const title = fieldObj?.name;
            const isEditDisabled = (synthecticId === placementNameArr[nameIndex]) || (fieldObj?.field_type === 9)|| (fieldObj?.field_type === 10);
            const isDisabled = (isEditDisabled || !taxonomySchemaArray?.length) ? 'placement-name-disabled' : 'placement-name';
            
            // update field name to taxonomy defined case
            let updatedName =  placementNameArr[nameIndex];
            if(fieldObj?.field_type !== 10){
                updatedName = PlacementUtils.transformValueToGivenCase(placementNameArr[nameIndex], fieldObj?.taxonomyTextcase);
            }

            return html` ${
                !placement.isOverride?
                html`<div part="placementName">
                        <omni-tooltip-next>
                            <span slot="invoker" id="placement-${placement.id}-${nameIndex}-name" part="${isDisabled}" class="placement dropdown" 
                                @click="${(event) => !isEditDisabled ? this.placementNameClick(event, nameIndex, placement, 'Placement Name',rowIndex):''}">
                                <span  id="placement-${placement.id}-${nameIndex}-span">${updatedName}</span>
                            </span>
                            <span slot="content">${title}</span>
                       </omni-tooltip-next>
                    </div>`
                : 
                html`  
                    <input id="placement-rate-${placement.id}"
                    part="cell-input"
                    class="input is-static is-editable"
                    type="text"
                    .value=${updatedName}
                    @blur=${(event) => this.updateOverideValue(event, rowIndex,placement.id,synthecticId)}>
                    ${synthecticId? ':|'+ synthecticId:''}   
                `
            }
            ${this.addingDelimiterValue(placement,placementObj,nameIndex,fieldObj,synthecticId)}
            ${(placement.isOverride || isEditDisabled || !taxonomySchemaArray?.length) ? '' : this.placementEditpopup(nameIndex, placement, 'Placement Name', 'Placement Schema', 'Placement Display Name',placementNameArr,taxonomyData)}`   
        });
        return rows;
    }

    /**
     * Adding delimeter after verifing all conditions
     * @param {object} placement placement all details 
     * @param {object} placementObj placement all input values as array last index and schema value
     * @param {number} nameIndex last index of placement name
     * @param {object} fieldObj field schema 
     * @returns returning delemeter if it's as per condition
     */
    addingDelimiterValue(placement,placementObj,nameIndex,fieldObj,synthecticId){
        let delemeter = fieldObj?.delimiterValue;
         
       if(placement.isOverride || !placementObj || placementObj?.nameLastIndex === nameIndex || (synthecticId && placementObj.nameArr.length - 2 === nameIndex)){
            delemeter = '';
       }
       return delemeter;
    }

    updateOverideValue= (event, index, id,synthecticId=null) => {
        let value = synthecticId? event.target.value + ':|'+ synthecticId:event.target.value;
        let tableData = this.state.tableData;
        let tableRow = tableData[index];
        if(tableRow && tableRow.id == id){
            tableRow['Placement Name'] =  value
        }else{
            tableRow?.nestedData.forEach(item=>{
                if(item.id == id){
                    item['Placement Name'] =  value
                }
            })   
        }
        tableData[index] = {...tableRow};
        this.setState({tableData:tableData},()=>{
            this.getlineItemPayload();
        });
    }

    /** The below code is a JavaScript function called `getSchemaWithoutHidden` 
     *   will store the values which are not hidden from taxonomy for various types of packages and placements.
     *  @param {package_type}  returns a string. 
     */
    getSchemaWithoutHidden  (placement)  {
        let taxonomyData = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.placementTaxonomyMap, this.allTaxonomyData);
        let placementSchemaArr = []
        taxonomyData && taxonomyData.fields.forEach((field, index) => {
            if(!field.hidden)  placementSchemaArr.push(field.name);
        })
        return placementSchemaArr.join('|');
    } 

    /**
     * Handles name edit in placement/parameter table name cell, and also returns without editing if the placement export status is accepted 
     * @param {object} event element of clicked name
     * @param {number} nameIndex name index
     * @param {number} rowIndex name row index
     * @param {object} placement placement all detail 
     * @param {string} nameType key from placement object to difrentiate between placement name and parameter code
     * @returns if status is Accepted
     */
    placementNameClick(event, nameIndex, placement,nameType,rowIndex) {
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        let addMorePlacementDropdown = querySelectorDeep('omni-table', 'right-table',parentNode)?.shadowRoot.querySelectorAll(".popup-placement-modal");
        let editPlacementPoup = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.querySelectorAll(".popup-placement-modal");
        if(addMorePlacementDropdown && addMorePlacementDropdown.length > 0){
            addMorePlacementDropdown.forEach(element => {
               element.setAttribute("part","dropdown");    
            });
        }
        if(editPlacementPoup && editPlacementPoup.length > 0){
            editPlacementPoup.forEach(element => {
               element.setAttribute("part","dropdown");    
           });
        }

        setTimeout(() => {
            this.selectedPlacementForNameEdit.nameIndex = nameIndex;
            this.selectedPlacementForNameEdit.placementId = placement.id;
            let clickElem = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(`placement-${placement.id}-${nameIndex}-name`);
            let ele = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(`popup-${placement.id}-${nameIndex}-${nameType}`);
           /* This code is positioning a dropdown element based on the position of a click
           element. It sets the "part" attribute of the dropdown element to "dropdown is-active",
           calculates the position of the dropdown element relative to the click element, and
           adjusts the margin-top of the dropdown element if it is too close to the bottom of the
           screen. It also positions the dropdown element by setting the position of its child
           elements to "initial". */
            if(ele){
                ele.setAttribute('part', 'dropdown is-active');
                ele.style.left = clickElem?.offsetLeft+"px";
                const eleRect = querySelectorDeep('omni-table', 'left-table',parentNode)?.getBoundingClientRect();
                const targetRect = clickElem.getBoundingClientRect();
     
                // Calculate the bottom position and move the dropdown to top for last 4 records
                const bottomPos = eleRect.bottom - targetRect.bottom;
                if(bottomPos < (ele.offsetHeight + 100)){
                    let tableData = this.state.tableData.length;
                    if(this.state.tableData.length > 2 && (tableData-1 == rowIndex || tableData-2 == rowIndex || tableData-3 == rowIndex)){
                        ele.style.marginTop  = `-${190}px`
                    }else{
                        ele.style.marginTop  = `-${116}px`
                    }   
                }else{
                    ele.style.marginTop  = `-${20}px`

                }
    
                // position the dropdown
                let dd =ele.querySelectorAll('om2-dropdown-impl') && ele.querySelectorAll('om2-dropdown-impl').length > 0 && ele.querySelectorAll('om2-dropdown-impl')[0].shadowRoot.querySelectorAll('.dropdown-content');
    
                dd && dd.forEach(element => {
                    if (element) {
                        element.style.position = 'initial';
                    }
                });
            }
            event.stopPropagation();
        });

    }

    /**
     * placementEditpopup function generates an HTML template for an edit popup to modify placement data for a specific index and row in a dropdown or input field.
     * @param {number} index - The index of the field within the placement data.
     * @param {Object} placement - The placement data object.
     * @param {string} placementKey - The key indicating the type of placement data, e.g., "placement_taxonomy".
     * @param {string} placementSchema - The key containing the placement schema.
     * @param {string} placementDisplay - The key containing the display value for the placement.
     * @returns {string} - An HTML template representing the edit popup for the placement.
     */
    placementEditpopup(index, placement,placementKey,placementSchema,placementDisplay,placementNameArr,taxonomyData) {
        let ddValue =  placementNameArr.length?placementNameArr[index]:'';
        let fieldName ='';
        let schemaArr = [];
        fieldName =  placement[placementSchema] ? placement[placementSchema].split('|')[index] : '';
        schemaArr =  placement[placementSchema] ? placement[placementSchema].split('|') : '';
        
        if(!fieldName || !ddValue){
            return ``;
        }
        const defaultTaxonomy = this.allTaxonomyData.defaultTaxonomyData;
        let {ddValues,validOptions, field} = PlacementUtils.getDropdownValues(fieldName,'placement_taxonomy',schemaArr,placementNameArr, placement,taxonomyData,defaultTaxonomy,true);
        if(field?.field_type === 9){
            return ``;
        }
        let applyButtonId = `edit-aply-btn-${index}-${placement.id}-${placementKey}`;
        const dropdownId = `popup-${placement.id}-${index}-${placementKey}`;
        const validationPattern = /^\d{1,5}\s?x\s?\d{1,5}(?:\s?-\s?[^ ].{0,19})?$/;
        let res = html`
            <div part="dropdown" class="popup-placement-modal" style="width: 349px" id="${dropdownId}">
            <div part="dropdown-menu" class="dropdown-menu1" role="menu">
                <div part="dropdown-content" class="dropdown-content" style="display: flex;flex-direction:column;padding: 10px 20px;text-align: left;">
                    <section part="dropdown-header">
                    ${ fieldName === 'Dimensions' 
                    ? html`<div class="object-title" style="display:flex; align-items:center; gap: 5px;">${fieldName}  
                    <omni-tooltip-next>
                    <omni-icon slot="invoker" class="is-size-4" icon-id="omni:informative:info"></omni-icon>
                    <div slot="content">Correct dimension format example: 100 x 100 - Demo Text 1</div>
                    </omni-tooltip-next>
                    </div>`
                    : html`<p class="object-title">${fieldName}</p>`
                    }   
                    </section>
                    <section part="dropdown-section" class="dropdown-item" style="padding-left: 4px">
                        <div part="dropdown-item" style="margin: 15px 0 20px 0">
                            ${(!ddValues || ddValues?.length === 0) ?
                html` <div  class="full-width">
                                <input part="input-control"  type="text" className="input text is-small"
                                .value="${ddValue}"
                                @change="${this.onPlacementInputChange.bind(this, placement,fieldName,applyButtonId)}"/>
                            </div>`
                :
                html` <div class="input-container">
                ${ fieldName === 'Dimensions' ||  fieldName === 'Dimension/Positions' ? 
                html`
                <omni-dropdown 
                typeahead 
                searchindropdown
                dynamicadditions
                hidefooter={true}
                .value="${PlacementUtils.getDropDownValue(fieldName,this.selectedDDValue,validOptions,ddValue)}"
                .options="${validOptions}"
                .originalOptions="${ddValues}"

                /**
                 * This function is executed when the input element's value changes. It processes the input value,
                 * trims and formats it according to specific conditions, performs validation, and triggers
                 * the corresponding function to update the state and apply button.
                 * @param {Event} event - The change event object triggered by the input element.
                 * @returns {void} - This function does not return a value; it performs side effects.
                 */
                @click="${()=>this.handleDimensionsClick(placement, index, placementKey)}"
                @change="${(event)=>this.handleDimensionsChange(event, fieldName, placement, applyButtonId, ddValue, ddValues, validOptions, validationPattern, dropdownId)}"
                ></omni-dropdown>`
                : html`
                <omni-dropdown
                    typeahead 
                    searchindropdown
                    hidefooter={true}
                    .value="${PlacementUtils.getDropDownValue(fieldName,this.selectedDDValue,validOptions,ddValue)}"
                    .options="${validOptions}"
                    .originalOptions="${ddValues}"
                    @click="${()=>this.handleDimensionsClick(placement, index, placementKey)}"
                    @change="${(e) => this.onPlacementDropDownChange(e.detail?.id, placement, applyButtonId,ddValues,fieldName)}"
                ></omni-dropdown>`
                }
                        </div>`
            }

                        </div>
                        <div class="action-btns" style="display: flex; justify-content: flex-end;align-items: center">
                        <button part="placement-name-cancel-button" @click=${(e) => this.onCancelPlacementUpdate(index, placement, applyButtonId,placementKey)}>Cancel</button>
                        <button part="placement-name-apply-button" id="${applyButtonId}" @click=${(e) => this.onApplyBtnClickForPlacementNameChange(index, placement,placementKey,placementSchema,placementDisplay,applyButtonId,placementNameArr)}>Apply</button>
                        </div>
                    </section>
                    
                </div>
            </div>
            </div>`;
        return res;
    }

    /** 
    * Description; to change the input value from dropdown
    * if condition will not enable apply btn till text box have value
    * @param {any} placement
    * @param {any} fieldName
    * @param {any} applyButtonId
    * @param {any} event
    * @returns {any}
    */
    onPlacementInputChange = (placement,fieldName,applyButtonId,event ) => {
        const updatedValue = event.target.value;
        
        // Get taxonomy data to check field restrictions
        let taxonomyData = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.placementTaxonomyMap, this.allTaxonomyData);
        let field = taxonomyData?.fields?.find(f => f.name === fieldName);
        
        // Check for space validation and also underscore validation using same flag
        if (field?.allowed_space === false && updatedValue && (updatedValue.includes(' ') || updatedValue.includes('_'))) {
            let invalidChar = updatedValue.includes(' ') ? 'Spaces' : 'Underscores';
            AlertMessagesService.showWarningToastMessage(`${invalidChar} are not allowed in ${fieldName}`);
            return;
        }
        
        if(updatedValue){
            let parentNode = document.getElementById('package-line-table').shadowRoot;
            this.selectedDDValue = {"value":updatedValue.split('_')[0],"name":fieldName};
            querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', 'placement-name-apply-button active')
        }else{
            this.selectedDDValue = null;
        }
    }

    /**
     * Handles the change event of the placement dropdown.
     * This function is responsible for processing the change event that occurs when a user
    * selects a different option in the placement dropdown. It performs several tasks, including
    * updating the selected dropdown value, validating the selected value using a regular expression
    * pattern, and modifying the appearance of the associated apply button based on the validation result.
     * @param {string} updatedValue - The updated value of the dropdown.
     * @param {string} placement - The placement information.
     * @param {string} applyButtonId - The ID of the apply button.
     * @param {Array} options - The array of options for the dropdown.
     * @param {string} fieldName - The name of the field associated with the dropdown.
     * @returns {void}
     */

    onPlacementDropDownChange = (updatedValue, placement, applyButtonId,options,fieldName) => {
        let selOpt = options.find(obj => obj.id === updatedValue) ? options.find(obj => obj.id === updatedValue) : {id:updatedValue,  value: updatedValue};
        const validationPattern = /^\d{1,5}\s?x\s?\d{1,5}(?:\s?-\s?[^ ].{0,19})?$/;
        if(selOpt){
            let parentNode = document.getElementById('package-line-table').shadowRoot;
            this.selectedDDValue =  {"value":updatedValue.split('_')[0],"label": selOpt.value, "name":fieldName,"option_id":selOpt.option_id};
            querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', 'placement-name-apply-button active')
            
            if(fieldName === 'Dimensions'){
                if(validationPattern.test(updatedValue)){ 
                    querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', 'placement-name-apply-button active')
                    querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.removeAttribute('disabled')
                }else{
                    querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', 'placement-name-apply-button')
                    querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('disabled', true)
                }
            }      
        }
    }
    /**
     * Handle a click event for dimensions in a table and show the related dropdown.
     * @param {string} placement - The placement for which the click event is triggered.
     * @param {number} index - The index of the element within the row.
     * @param {string} placementKey - The unique key associated with the placement.
     */
    handleDimensionsClick = (placement, index, placementKey) => {
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        let ele = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(`popup-${placement.id}-${index}-${placementKey}`).querySelector('omni-dropdown')?.shadowRoot.querySelector('.dropdown');
        ele && ele.setAttribute('part', 'dropdown is-active');
    }

    /**
     * Handle a change in dimensions or dropdown value and trigger related actions.
     * The function is designed to respond to changes in either dimensions or dropdown values. 
     * When such changes occur, it initiates a series of actions that are closely related to the specific context in which the change occurs.
     * @param {Event | { value: string, detail: string }} event - The event object or a value to handle.
     * @param {string} fieldName - The name of the field being updated.
     * @param {string} placement - The placement related to the change.
     * @param {string} applyButtonId - The ID of the apply button.
     * @param {string} ddValue - The selected dropdown value.
     * @param {Array<{ id: string, label: string, value: string }>} ddValues - Available dropdown values.
     * @param {Array<{ value: string }>} validOptions - Valid options for the dropdown.
     * @param {RegExp} validationPattern - Regular expression for validation.
     */
    handleDimensionsChange = (event, fieldName, placement, applyButtonId, ddValue, ddValues, validOptions, validationPattern, dropdownId) => {
        // Determine the current dropdown value
        const dropdownValue = PlacementUtils.getDropDownValue(fieldName,this.selectedDDValue,validOptions,ddValue);
        // Get the new value from the event
        let newEventValue = event.detail.id ? event.detail.id.trim() : event.detail;
        // Check if the new value is different from the dropdown value
        if(dropdownValue[0].value.trim() !== newEventValue.trim() && fieldName === 'Dimensions'){
            newEventValue = newEventValue.replace(/x/g, " x ").replace(/-/g, " - ");
            newEventValue = newEventValue.replace(/\s+/g, " ");
            this.onPlacementDropDownChange(newEventValue, placement, applyButtonId,ddValues,fieldName);
        }else{
            this.onPlacementDropDownChange(newEventValue, placement, applyButtonId,ddValues,fieldName);
        }
        if(fieldName === 'Dimensions'){
            let parentNode = document.getElementById('package-line-table').shadowRoot;
            if(validationPattern.test(newEventValue)){
                querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(dropdownId).querySelector('omni-dropdown')?.removeAttribute('error')
            }else{
                querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(dropdownId).querySelector('omni-dropdown')?.setAttribute('error', 'Wrong format entry, see info example')
            }
        }
    }

    /**
     * Handle a click event for the cancel button in a placement name update.
     * @param {number} nameIndex - The index of the name within the row.
     * @param {string} placement - The placement for which the name is being updated.
     * @param {string} applyButtonId - The ID of the apply button.
     * @param {string} placementKey - The unique key associated with the placement.
    */ 
    onCancelPlacementUpdate = (nameIndex, placement, applyButtonId,placementKey) => {
        this.selectedDDValue = null;
        this.selectedPlacementForNameEdit.rowIndex = -1;
        this.selectedPlacementForNameEdit.nameIndex = -1;
        // Placement Edit Cancel
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        if(querySelectorDeep('omni-table', 'left-table',parentNode)){
            querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(applyButtonId)?.setAttribute('part', 'placement-name-apply-button')
            let ele = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(`popup-${placement.id}-${nameIndex}-${placementKey}`);
            ele && ele.setAttribute('part', 'dropdown');
        }
    }

    /**
     * Handle a click event for the apply button in a placement name update.
     * @param {number} nameIndex - The index of the name within the row.
     * @param {string} placement - The placement for which the name is being updated.
     * @param {string} placementKey - The unique key associated with the placement.
     * @param {string} placementSchema - The schema for the placement.
     * @param {string} placementDisplay - The display for the placement.
     * @param {string} applyButtonId - The ID of the apply button.
     * @param {Array<string>} placementNameArr - The array of placement names.
     */ 
    onApplyBtnClickForPlacementNameChange(nameIndex, placement,placementKey,placementSchema,placementDisplay,applyButtonId,placementNameArr){
        if(!this.selectedDDValue) return;
        let fieldName = placement[placementSchema].split('|')[nameIndex];
        let taxonomySchemaArray = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.placementTaxonomyMap, this.allTaxonomyData)?.fields;
        const updatedPlacement = this.updatePlacementNameState(nameIndex, fieldName, placement,placementKey,placementSchema,placementDisplay,placementNameArr,taxonomySchemaArray);

        if(!!updatedPlacement["fieldsWithCascaded"].length){
            this.onUpdateInvalidFields(nameIndex, updatedPlacement,placementKey);
            return ;
        }
        if(this.isAnyInvalidFields(nameIndex,updatedPlacement,placementKey)){
            return;
        }
        
        this.selectedDDValue = null;
        let tableData = [...this.state.tableData];
        this.updatePlacement(tableData, updatedPlacement);
        this.setState({tableData:tableData},()=>{
            this.getlineItemPayload();
            this.onCancelPlacementUpdate(nameIndex, placement,applyButtonId,placementKey)
        })
    }

    /** Update the table row on change of dropdown value
    * @param {array} tableData - The table data array.
    * @param {object} updatedPlacement - The updated placement object.
    */ 
    updatePlacement = (tableData, updatedPlacement) => {
        for(let i=0; i < tableData?.length; i++){
            if(Number(tableData[i].id) === Number(updatedPlacement.id)){
                tableData[i] = updatedPlacement;
                return;
            } else {
                this.updatePlacement(tableData[i].nestedData, updatedPlacement);
            }
        };
    }

    /**
       * The  code is a function called `updatePlacementNameState` updates the state of a placement name based on the selected value from a dropdown menu
    * it will map the package or placement types after checking the filedName
    * @param {string}  `nameIndex`,
    * @param {string}  `fieldName`
    * @param {string}  `placementKey` key string of object in placement
    * @param {string}  `placementSchema` key string of object in placement
    * @param {string}  `placementDisplay` key string of object in placement
    * @param {array}  `inputplacement`. It takes in the index of the name to be updated
       * @returns The name of the field, and the selected value from the dropdown menu as input parameters.
       */
    updatePlacementNameState = (nameIndex, fieldName, inputplacement,placementKey,placementSchema,placementDisplay,PlacementNameArr,taxonomySchemaArray) => {
        let placement = inputplacement;
        
        placement[this.selectedDDValue.name] = this.selectedDDValue.value;
        let taxonomyData = PlacementUtils.getDialogTaxonomyData(this.state, PlacementUtils.mapPackageType(placement.package_type, placement.placement_type, placement.parent_type), this.placementTaxonomyMap, this.allTaxonomyData);
        let isHiddenField = taxonomyData?.fields?.filter(field=> field.hidden == false)?.length
        let {taxonomySelectedValueJson} = PlacementUtils.createNames(placement,taxonomyData,true)

        placement[placementKey] = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,taxonomyData?.fields);
        placement[placementDisplay] = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',false,taxonomyData?.fields);

        placement[placementSchema] = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'field_name',false,taxonomyData?.fields);
        if(isHiddenField){
            placement["Override Placement Name"] =  PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',true,taxonomyData?.fields);
            placement["Override Placement Display Name"]  = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',true,taxonomyData?.fields);
        }
        // just delete field_name, name from taxonomySelectedValueJson before saving in state
        taxonomySelectedValueJson = taxonomySelectedValueJson.map((item) => {
            delete item['field_name'];
            delete item['name'];
            delete item['hidden'];
            return item;
        });
        placement['taxonomy'] = taxonomySelectedValueJson;
        
        let fieldsWithCascaded = [];
        // to check either dropdown select(not for text input)
        let filedArrayList = [];
        if(this.selectedDDValue.option_id && taxonomySchemaArray){
            let optionList =  taxonomySchemaArray.find(obj => obj.name === fieldName);;
            filedArrayList = taxonomySchemaArray;
           
            let matchedItem = optionList.fielditems.find(fObj => fObj.id === this.selectedDDValue.option_id);
            let childItems = matchedItem ?  matchedItem.childitems : [];
            if(!!childItems?.length){
                let childFieldIArr = childItems.map((chObj) => Number(chObj.FieldId));
                childFieldIArr = [...new Set(childFieldIArr)];
                childFieldIArr.map((fId) => {
                    let matched = taxonomySchemaArray.find((fObj) =>fObj.id === fId )
                    if(matched){
                        let f_name =matched.name;
                        let f_index = schemaArr.indexOf(f_name);
                        let f_val = nameArr[f_index];
                        let childItemsValues = childItems.filter((chItem) => Number(chItem.FieldId ) === fId);
                        let isMatched = childItemsValues.find((chItem) => chItem.Code === f_val);
                        if(!isMatched){
                            fieldsWithCascaded.push({id:matched.id,name:f_name,nameIndex:f_index,childItems:childItemsValues});
                        }
                    }
                })
            }
        }      
        // placement[placementSchema] = schema;
        placement["updatedValue"] = this.selectedDDValue.value;
        placement["fieldsWithCascaded"] = fieldsWithCascaded;
        return placement;
    }

    /** 
    * Checks if there are any invalid fields in a table row
    * @param {string}  `nameIndex`,
    * @param {string}  `placementKey` key string of object in placement
    * @param {array}  `updatedPlacement`. It then sets a variable `isInvalid` to false and selects a specific cell in the table using `querySelector`.If there is an element with a specific class name in the cell, it removes it.
    * @returns It then sets a variable `isInvalid` to false and selects a specific cell in the table using `querySelector`.If there is an element with a specific class name in the cell, it removes it. 
    */
    isAnyInvalidFields = (nameIndex,updatedPlacement,placementKey) =>{
        let isInvalid = false;
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        let currentCell  =   querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.querySelector(`span[id='placement-${updatedPlacement.id}-${nameIndex}-name'`);
        if(currentCell.closest("td").querySelector(`.invalid-selection-${nameIndex}`)){
            currentCell.closest("td").querySelector(`.invalid-selection-${nameIndex}`).remove();
        }
        if(currentCell.closest("tr").querySelector(".invalid")){
            isInvalid = true;
        }
        if(isInvalid){
            let ele = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(`popup-${updatedPlacement.id}-${nameIndex}-${placementKey}`);
            let cellEle  =   ele.closest("td").querySelector(`span[id='placement-${updatedPlacement.id}-${nameIndex}-name'`);
            let textEle = cellEle.querySelector(`span[id=placement-${updatedPlacement.id}-${nameIndex}-span]`);
            textEle.text = updatedPlacement["updatedValue"]
            ele.setAttribute('part', 'dropdown');
        }
        return isInvalid;
    }

    /**
     * onUpdateInvalidFields function updates the placement table with invalid fields and cascaded dropdowns based on the provided data.
     * @param {number} nameIndex - The index of the field name in the placement table.
     * @param {Object} updatedPlacement - The updated placement data object.
     * @param {string} placementKey - The key indicating the type of placement data, e.g., "placement_taxonomy".
     * @returns {void}
     */
    onUpdateInvalidFields =  (nameIndex, updatedPlacement,placementKey) =>{
        let parentNode = document.getElementById('package-line-table').shadowRoot;
        let querySelector = querySelectorDeep('omni-table', 'left-table',parentNode)
        let ele = querySelector?.shadowRoot.getElementById(`popup-${updatedPlacement.id}-${nameIndex}-${placementKey}`);
        let cellEle  =   ele.closest("td").querySelector(`span[id=placement-${updatedPlacement.id}-${nameIndex}-name`);
        let textEle = cellEle.querySelector(`span[id=placement-${updatedPlacement.id}-${nameIndex}-span]`);
        textEle.text = updatedPlacement["updatedValue"]
        ele.setAttribute('part', 'dropdown');

        /* This code is checking if there is an element with class name
        `invalid-selection-` inside the closest `td` element of the `ele` element. If
        such an element exists, it is removed from the DOM using the `remove()` method. */
        if(ele.closest("td").querySelector(`.invalid-selection-${nameIndex}`)){
            ele.closest("td").querySelector(`.invalid-selection-${nameIndex}`).remove();
        }
        let fieldsWithCascaded = updatedPlacement["fieldsWithCascaded"];
        fieldsWithCascaded.map((field) => {
            let validValues = field.childItems.map(item =>item.Code);
            let cascadePopup = querySelectorDeep('omni-table', 'left-table',parentNode)?.shadowRoot.getElementById(`popup-${updatedPlacement.id}-${field.nameIndex}-${placementKey}`);
            ele.closest("td").querySelector(`span[id='placement-${updatedPlacement.id}-${field.nameIndex}-name'`).click();
            if(!ele.closest("td").querySelector(`span[id='placement-${updatedPlacement.id}-${field.nameIndex}-name'`).querySelector(`.invalid-selection-${field.nameIndex}`))
                ele.closest("td").querySelector(`span[id='placement-${updatedPlacement.id}-${field.nameIndex}-name'`).insertAdjacentHTML("afterBegin",`<span class="invalid invalid-selection-${field.nameIndex}" style="color:red;font-weight:bold;">[Invalid Selection!]</span>`);
            
            /* This code is checking if the `om2-dropdown` element inside the `cascadePopup` element has
            a property called `originalOptions`. If it doesn't have this property, the code sets the
            `originalOptions` property to the current options of the `om2-dropdown` element. This is
            useful for storing the original options of the dropdown before any changes are made to
            it, so that they can be restored later if needed. */
            if(cascadePopup.querySelector('omni-dropdown')){
                if(!cascadePopup.querySelector('omni-dropdown').originalOptions){
                    cascadePopup.querySelector('omni-dropdown').originalOptions = cascadePopup.querySelector('omni-dropdown').options;
                }
                let _options = [];
                cascadePopup.querySelector('omni-dropdown').originalOptions.map((opt) => {
                    if(validValues.includes(opt.value)){
                    _options.push(opt);
                    }
                });
                setTimeout(() =>{
                    cascadePopup.querySelector('omni-dropdown').options = _options;
                },100);
        }else{
            if(!cascadePopup.querySelector('om2-dropdown').originalOptions){
                cascadePopup.querySelector('om2-dropdown').originalOptions = cascadePopup.querySelector('om2-dropdown').options;
            }
            let _options = [];
            cascadePopup.querySelector('om2-dropdown').originalOptions.map((opt) => {
                if(validValues.includes(opt.value)){
                _options.push(opt);
                }
            });
            setTimeout(() =>{
                cascadePopup.querySelector('om2-dropdown').options = _options;
            },100);
        }
        })
    }

    /**
     * Search Line Item according values
     * @param {Any} event 
     */
    updateSearch = (event) => {
        let searchParam = event.detail.value;
        let searchTableData = [];
        let tableData = [...this.state.tableData];
        if(searchParam){
            searchTableData = tableData.filter(val=>{
                let placementName = val['Placement Name'].toLocaleLowerCase();
                searchParam = searchParam.toLocaleLowerCase();
                return placementName.includes(searchParam);
            });
            this.setState({storeTableData : searchTableData});
        }else{
            this.setState({storeTableData : []});
        }

    }
    /**
     * Function to check for the invalid characters in the input field
     * @param {Object} e - Event object
     * @returns {void}
     */ 
    blockInvalidChar = e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();

    /**
     * Update value of state property "addLineItem" on change of input
     * @param {object} event 
     */
    onUpdateAddLineItemInput(event){
          this.setState({
            addLineItem:event.target.value
        }); 
    }

    /**
     * Creating Placement line item, footer input box
     */
    addLineItemWithRemaingBudget(){
        let tableData = this.state.tableData;
        let placementObj = {...this.state.programmaticUpdateformData};
        // let rate =  Number(placementObj['Rate']);
        let placementArr = [];
        for(let i= 0; i< this.state.addLineItem;i++){
            placementArr.push({...placementObj});
        }
        placementArr = this.createIds(placementArr);
        placementArr = this.calculateRemaingBudget(placementArr);
        tableData.push(...placementArr);
        this.setState({tableData:tableData,addLineItem:''},()=>{
            this.getlineItemPayload();
            this.calculateBudget();
        });
    }
    /**
     * function is calculate remaing budget for child item, when copy and create line,
     * function will calculate remaing budget and assign equally to new created or copying placement.
     *  @param { Array} placementList list of new placement list
     *  retun list of new placement with new assign cost and unit value
     */
    calculateRemaingBudget(placementList){
        let currentTotalOfLine = this.state.budgetArray.reduce((prev, curr, index, array) => prev + Number(curr['planned_cost']), 0)
        let currentTotalUnit = this.state.budgetArray.reduce((prev, curr, index, array) => prev + Number(curr['unit_amount']), 0)
        let pendingBudget = this.state.budget - currentTotalOfLine;
        let unit = 0;
        let cpmUnit = 0;
        let pendingUnit = 0
        if(pendingBudget > 0){
            pendingUnit  = this.state.programmaticUpdateformData['Unit Amount']-currentTotalUnit;
            unit = pendingUnit/Number(placementList.length);
            if(unit < 1){
                unit = 1;
            }
        }
        
        unit = unit? Math.floor(unit) : unit;
        placementList.forEach((values)=>{
            let rate =  Number(values['Rate']);
            values['Unit Amount']  = unit;
            if(values['costMethod'] && values['costMethod'].includes('CPM')){
                cpmUnit = unit / 1000;
                cpmUnit = cpmUnit? Math.floor(cpmUnit) : cpmUnit;
                values['Planned Cost']  = rate * cpmUnit
            }else{
                values['Planned Cost']  = rate * unit
            }
            if(pendingUnit && unit == 1){
                pendingUnit = pendingUnit - unit;
                if(!pendingUnit){
                    unit = 0;
                }  
            }
        });
        return placementList;
    }

    /**
     * Function to update the table data with new creative data
     * @param {Array} creativeData - Array of creative data to be added to the table
     * @param {number} lineItemId - ID of the line item to which the creative data belongs
    */
    updateTableData = (creativeData, lineItemId) => {
        let tableData = [...this.state.tableData];
        const findLineItem = (data) => {
            let lineItem = data.find(item => item.id === lineItemId);
            if(lineItem){
                lineItem.nestedData = creativeData;
                return;
            } else {
                for(let i=0; i<data.length; i++){
                    if(data[i].nestedData?.length){
                        findLineItem(data[i].nestedData);
                    }
                }
            }
        };
        findLineItem(tableData);
        this.setState({ tableData });
    }

    /**
     * On expand call creative API for expanded Line Item 
     * @param {object} event 
     */
    expandOrCollapseRows = (event) => {
        let lineItem = event.detail;
        if(!lineItem?.nestedData?.length){
            this.props.parentProps?.setSpinnerCount(1);
            CreateCreativeService.getCreativeByPlacementId(lineItem?.placements_id).then((response) => {
                if(response?.data.length){
                    this.updateTableData(response.data, lineItem?.id);
                } else {
                    AlertMessagesService.showInfoToastMessage("No creative data found for this placement.");
                }
                this.props.parentProps?.setSpinnerCount(0);
            }).catch((error) => {
                this.props.parentProps?.setSpinnerCount(0);
                AlertMessagesService.showErrorToastMessage("Error fetching creative data");
            });
        }
    }

    render() {
        return (<>
        <div className='line-item-container'>
            <div className='placement-details-table-container'>
                {!!this.state.tableData?.length && this.state.budget && this.state.budgetArray.length &&
                    <PlacementDetailsTableSummaryHeader data={this.state.budgetArray} campaignObj={{campaign_total_budget:this.state.budget,isTotalBudget:true} } unitDetail={{totalUnit:this.state.programmaticUpdateformData['Unit Amount']}} isCreateChild={true}
                    currencyName={this.state.campaignObj.local_currency_name} isLocal={this.state.systemParametersData.data.isLocal}></PlacementDetailsTableSummaryHeader>
                }
            </div>
            {!!this.state.tableData?.length &&  ( 
            <>
                <OmniTileComponent heading="">
                    <OmniToolbarComponent slot="header">
                        <label slot="start">Line and Creative details</label>
                        <div slot="end" className="custom-dropdown-menu">
                            <OmniTooltipNextComponent>
                                <button disabled={!this.state.selectedData?.length} part="icon-button" slot="invoker" aria-haspopup="true" className="icon header-icon-button"
                                    onClick={() => this.copyPlacements(null,'bulkCopy')}>
                                    <OmniIconComponent className="is-size-4 header-icon" icon-id="omni:interactive:copy"></OmniIconComponent>
                                </button>
                                <div slot="content">Copy</div>
                            </OmniTooltipNextComponent>
                        </div>
                        <div slot="end" className="custom-dropdown-menu">
                            <div className="Line-Copy-2"></div>
                            <OmniSearchComponent className="search-input-icon" onSearchUpdate={this.updateSearch} slot="end" ph="Search"></OmniSearchComponent>
                        </div>
                    </OmniToolbarComponent>
                </OmniTileComponent>
                <OmniTableStickyComponent
                        class="card"
                        id="package-line-table"
                        data={this.state.storeTableData.length ?this.state.storeTableData:this.state.tableData}
                        leftColumns={this.getLeftColumn()}
                        rightColumns={this.getRightCoumn()} 
                        key={this.state.tableData.length}
                        keyFn={row => row && row.id}
                        expandAllOnLoad={false}
                        onExpandOrCollapse={this.expandOrCollapseRows}
                        stickyscrollbar={true}
                    >
                    <div slot='table-footer' className='table-footer'>
                        {(this.state.tableData?.length === 0 && (this.state.searchParam || this.state.filterApplied)) && <div>{ this.state.filterApplied ? "No Data Found!" :  `No Data Found For  "${this.state.searchParam}" `}</div>}
                    </div>
                    </OmniTableStickyComponent>
                </>
            )}
            <div className='add-line-item-container'>
                <div className="input-container">
                    <label htmlFor="budget"># of Lines</label>
                    <input id="add-line-item"
                        type="number"
                        min="0"
                        onKeyDown={this.blockInvalidChar}
                        value={this.state.addLineItem}
                        onChange={(e) => this.onUpdateAddLineItemInput(e)}
                        className="input text is-small"
                    />
                </div>
                <button className="secondary" disabled={!this.state.addLineItem}   onClick={() =>this.addLineItemWithRemaingBudget()}>+ Add Line(s)</button>
            </div>
        </div>
        </>
        );
      }

}